import SearchArrowIcon from 'app/components/icons/SearchArrowIcon';
import { useState } from 'react';

export default function IntegratedSearchInput({
  onClickSearch,
  placeholder,
  disableWhenEmpty = false,
}: {
  onClickSearch: (search: string) => void;
  placeholder?: string;
  disableWhenEmpty?: boolean;
}) {
  const [search, setSearch] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    if (disableWhenEmpty && !search) {
      return;
    }

    e.preventDefault();
    onClickSearch(search);
    setSearch('');
  };

  return (
    <div
      id="ostro-integrated-search-container"
      className="relative w-full"
    >
      <form
        onSubmit={handleSubmit}
        className="flex items-center border border-[#1E1E1E] rounded-[4px] overflow-hidden mb-0"
      >
        <input
          id="ostro-integrated-search-input"
          data-testid="ostro-integrated-search-input"
          className={`
            flex-grow
            h-[50px]
            p-4
            text-sm
            outline-none
            text-typography-secondary
            placeholder:text-typography-placeholder
            focus:placeholder:text-transparent
            [&::-webkit-search-cancel-button]:appearance-none
            [&::-webkit-search-decoration]:appearance-none
            bg-white
          `}
          placeholder={placeholder}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          type="search"
        />
        <button
          data-testid="ostro-integrated-search-button"
          id="ostro-integrated-search-button"
          className="bg-white h-[50px] px-4 flex items-center justify-center"
          aria-label="Search"
          type="submit"
          disabled={disableWhenEmpty && !search}
        >
          <SearchArrowIcon />
        </button>
      </form>
    </div>
  );
}
